import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type SessionContextService from 'tio-employee/services/session-context';
import type PreRegisterService from 'tio-employee/services/pre-register';
import type SessionService from 'tio-employee/services/session';
import type RouterService from '@ember/routing/router-service';
import type CableService from 'tio-common/services/cable';

export default class LogoutRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare preRegister: PreRegisterService;
  @service declare session: SessionService;
  @service declare router: RouterService;
  @service declare cable: CableService;

  async beforeModel() {
    // Capture the IdP's SLO URL before clearing session state, since
    // preRegister settings are available pre-auth and won't be affected by logout.
    const idpSloUrl = this.preRegister.settings?.idpSloUrl;

    this.cable.disconnect();

    // Prevent handleInvalidation from firing a competing transition to /logout
    // by flagging the session, then performing a full logout.
    this.session.isLoggingOut = true;
    await this.sessionContext.logout();

    if (idpSloUrl) {
      window.location.assign(idpSloUrl);
    } else {
      this.router.transitionTo('/logged-out');
    }
  }
}
